import { Component, OnInit } from '@angular/core';
import { CategoryItem } from '../../../data/vod/models/category-item';
import { BasePageComponent } from '../../../views/commons/base-page/base-page.component';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { VodDataRestService } from '../../../data/vod/vod-data-rest.service';
import { BtvDataRestService } from '../../../data/btv/btv-data-rest.service';
import { DeviceDetectorService } from 'ngx-device-detector';

declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent extends BasePageComponent implements OnInit {

  get currentYear() {
    return (new Date()).getFullYear();
  }

  isDesktop: boolean;
  categories: CategoryItem[];
  genres: any[];

  constructor(helpers: HelpersService,
    vodService: VodDataRestService,
    btvService: BtvDataRestService,
    deviceService: DeviceDetectorService
  ) {
    super(helpers);
    // Replace with Menu service
    // vodService.getCategories().subscribe(data => this.categories = data);
    // btvService.getChannelLists().subscribe(data => this.genres = data);
    this.isDesktop = deviceService.isDesktop();
  }

  ngOnInit() {
  }

  showModal() {
    $('#modal-about').modal('show');
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/layouts/widgets/footer/footer.component.ts